export const gitSha: string | undefined =
  typeof import.meta.env.VITE_GIT_SHA === "string" ? import.meta.env.VITE_GIT_SHA : undefined;
